<template>
  <div id="app" class="m-viewport">
    <div class="video-box"><video muted="muted" loop="loop" autoplay="autoplay" height="1080" width="1920" style="object-fit: fill;"><source src="https://web-resource.17m3.com/m3guo/202201/invite/video.mp4" type="video/mp4"></video></div>
    <h1 class="logo"><a href="https://www.m3guo.com/v2/" target="_blank" class="u-btn game-web"></a></h1>
    <div class="ui-top">
      <div class="wrapper">
        
        <div class="main-title"></div>

        <div class="page-ctrl">
          <router-link to="/invite" class="page-invite" active-class="act">召唤老友</router-link>
          <router-link to="/back" class="page-return" active-class="act">我要回归</router-link>
          <div class="u-btn rule" @click="$evt_rule_modal()"></div>
        </div>

      </div>

      <div class="ui-link">
        <div class="link-item">
          <div class="u-btn login" @click="$mslogin.open()" v-if="!login"></div>
          <div class="u-btn logout"
            @click="logout"
            v-else>
          </div>
        </div>
        <div class="link-item">
          <a href="https://www.m3guo.com/v2/" target="_blank" class="u-btn game-web"></a>
        </div>
        <div class="link-item">
          <a href="https://www.m3guo.com/v2/download/client/" target="_blank" class="u-btn game-dl"></a>
        </div>

        <div class="user-info" v-if="login">
          <span class="u-bind" v-if="!ua.areaId" @click="$bind()">【绑定大区】</span>
          <span v-else>【{{$query_area(ua.areaId)}}】</span>
          <span class="user-name">{{ userName() }}</span>
        </div>        
      </div>
    </div>

    <transition name="fade" mode="out-in" appear>
      <router-view v-if="ready" :ua="ua" :login="login"></router-view>
    </transition>
    
    <tips-pc ref="tips" v-show="tips_visible"></tips-pc>
  </div>
</template>

<script>
import '@/css/style.css';
// item_tips
import Item_Tips_PC from '@/components/ItemTipsPC/itemTipsPC.vue';
// import Item_Tips_APP from '@/components/ItemTips/itemTips.vue';

export default {
  name: 'App',
  data () {
    return {
      user_trriger : false,
      tips_visible : false,
    }
  },
  props : {
    ready : {
      default : false,
    },
    ua : {
      default : {},
    },
    login : {
      default : 0,
    },
  }, 
  components : {
    'tips-pc' : Item_Tips_PC,
  },
  methods : {
    logout (){
        localStorage.setItem("token", "");
        setTimeout(function () {  
            location.reload();
        }, 100);       
    },
    userName(){
      return this.ua.nickName || this.ua.uid;
    }
  }
}
</script>

<style scoped>
@media screen and (min-device-width: 1025px){
.m-viewport{
  position: relative;
  max-width: 1920px;
  margin: 0 auto;
  overflow-x: hidden;
  background-color: #ecddbc;
}

.video-box {
    position: absolute;
    width: 1920px;
    height: 920px;
    left: 50%;
    top: -16px;
    margin-left: -960px;
    pointer-events: none;
    overflow: hidden;
    z-index: 9;
}

.m-viewport .wrapper{
  position: relative;
  width: 1000px;
  margin: 0 auto;
}

.m-viewport .logo{
  position: absolute;
  top: 10px;
  left: 2%;
  width: 95px;
  height: 74px;
  background-image: url(../../images/logo.png);
  z-index: 10;
}

.m-viewport .logo a{
  display: block;
  width: 100%;
  height: 100%;
}

.m-viewport .main-title{
  width: 308px;
  height: 408px;
  margin-left: 140px;
  background-image: url(../../images/main-title.png);
}

.ui-top{
  position: relative;
  width: 100%;
  height: 912px;
  padding-top: 75px;
  background-position: top center;
  box-sizing: border-box;
  background-image: url(../../images/top.jpg);
}

.ui-top .page-ctrl{
  position: relative;
  display: flex;
  align-items: center;
  font-size: 0;
  color: transparent;
  margin-top: 150px;
  z-index: 10;
}

.ui-top .page-ctrl>div{
  cursor: pointer;
}

.page-invite{
  width: 289px;
  height: 93px;
  margin-left: 70px;
  background-image: url(../../images/page-invite.png);
}

.page-invite:hover{
  background-image: url(../../images/page-invite_hover.png);
}

.page-invite.act{
  background-image: url(../../images/page-invite_hover.png);
}

.page-return{
  width: 289px;
  height: 93px;
  margin-left: 90px;
  background-image: url(../../images/page-return.png);
}

.page-return:hover{
  background-image: url(../../images/page-return_hover.png);
}

.page-return.act{
  background-image: url(../../images/page-return_hover.png);
}

.u-btn.rule{
  width: 144px;
  height: 39px;
  margin-left: 30px;
  background-image: url(../../images/btn-rule.png);
}

.u-btn.rule:hover{
  background-image: url(../../images/btn-rule_hover.png);
}

.ui-link{
  display: flex;
  position: absolute;
  top: 20px;
  right: 2%;
  z-index: 10;
}

.ui-link .link-item{
  width: 70px;
  margin-right: 20px;
}

.ui-link .u-btn{
  display: block;
  width: 70px;
  height: 85px; 
  margin: 0 auto;
  cursor: pointer;
  background-repeat: no-repeat;
}

.ui-link .login{
  background-image: url(../../images/btn-login.png);
}

.ui-link .login:hover{
  background-image: url(../../images/btn-login_hover.png);
}

.ui-link .logout{
  position: relative;
  background-image: url(../../images/btn-logout.png);
}

.ui-link .logout:hover{
  background-image: url(../../images/btn-logout_hover.png);
}

.ui-link .user-info{
  position: absolute;
  bottom: -45px;
  left: 0;
  width: 265px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #f4e0c3;
  background-image: url(../../images/bg-userinfo.png);
}

.ui-link .user-info::after{
  display: block;
  content: '';
  position: absolute;
  top: -16px;
  left: 22px;
  width: 20px;
  height: 20px;
  background-image: url(../../images/icon-arrow.png);
}

.ui-link .user-name{
  width: 120px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ui-link .game-web{
  background-image: url(../../images/btn-web.png);
}

.ui-link .game-web:hover{
  background-image: url(../../images/btn-web_hover.png);
}

.ui-link .game-dl{
  background-image: url(../../images/btn-dl.png);
}

.ui-link .game-dl:hover{
  background-image: url(../../images/btn-dl_hover.png);
}

.u-bind{
  cursor: pointer;
}
}

</style>



// WEBPACK FOOTER //
// src/view/pc/pc.vue